module.exports = __webpack_public_path__ + "static/media/play.df030398.svg";